export default "__VITE_ASSET__BTHwnB0G__"